import { render, staticRenderFns } from "./QuoteSlider.vue?vue&type=template&id=091280ef"
import script from "./QuoteSlider.vue?vue&type=script&lang=js"
export * from "./QuoteSlider.vue?vue&type=script&lang=js"
import style0 from "./QuoteSlider.vue?vue&type=style&index=0&id=091280ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports